import { Group, Select, Stack } from '@mantine/core';
import { FC } from 'react';

import { DatasetsInfo } from '@mygpt/app';

export interface DatasetSelectProps {
  datasets: DatasetsInfo[];
  value: string;
  onChange: (value: string | null) => void;
  disabled?: boolean;
  withAsterisk?: boolean;
  label?: string;
  size?: string;
}

export const DatasetSelect: FC<DatasetSelectProps> = ({
  datasets,
  disabled,
  label,
  onChange,
  size = 'xs',
  value,
  withAsterisk,
}) => {
  return (
    <Stack>
      <Group gap="xs" className="relative">
        <Select
          label={label}
          withAsterisk={withAsterisk}
          className="w-full"
          size={size}
          allowDeselect={false}
          disabled={disabled}
          value={value}
          onChange={onChange}
          data={datasets.map((value) => ({ value: value.id, label: value.name }))}
        />
      </Group>
    </Stack>
  );
};
